import { ref } from 'vue';

// Module-level singleton refs — shared across all callers.
export const windowWidth = ref(window.innerWidth);
export const windowHeight = ref(window.innerHeight);

const handleResize = () => {
  windowWidth.value = window.innerWidth;
  windowHeight.value = window.innerHeight;
};

window.addEventListener('resize', handleResize);

export default function useWindowSize() {
  return { windowWidth, windowHeight };
}
